<template>
  <div class="flex w-full flex-col py-8">
    <div class="w-full border-b-2 border-b-primary pb-4">
      <span class="text-4xl font-medium">
        {{ __('Recommended Products') }}
      </span>
    </div>

    <div class="pt-4">
      <div
        class="scrollbar-thin grid grid-cols-1 gap-x-10 gap-y-20 overflow-x-auto rounded-lg bg-white p-8 shadow-md sm:max-h-[800px] md:grid-cols-2 lg:grid-cols-3"
      >
        <div
          v-for="(product, index) in data.product.recommended_products.data"
          :key="product.id"
          class="hover-lift-no-shadow flex flex-col gap-y-5"
        >
          <!-- Image -->
          <div
            @click.prevent="
              redirectToPage(
                'redesign.candidate.shop.products.show',
                product.id
              )
            "
            class="relative aspect-square cursor-pointer overflow-hidden rounded-lg"
          >
            <img
              :src="`/uploads/${product.image.path}`"
              :key="product.image.id"
              :alt="__('Media image')"
              class="h-full w-full object-cover shadow-md transition-all duration-200 hover:shadow-lg"
            />
            <Icon
              v-if="product.unlocked"
              name="jobful_unlocked"
              class="absolute right-0 top-2"
            >
            </Icon>
            <Icon v-else name="jobful_locked" class="absolute right-0 top-2">
            </Icon>
            <div class="absolute bottom-2 left-4 flex flex-col gap-y-2">
              <div
                class="flex w-fit items-center justify-start rounded-xl bg-gray-50 px-2 py-0.5 text-sm text-zinc-800"
              >
                {{ product.category_name }}
              </div>
              <div
                class="flex w-fit items-center justify-start rounded-xl bg-gray-50 px-2 py-0.5 text-sm text-zinc-800"
              >
                <span
                  class="inline-block max-w-32 overflow-hidden text-ellipsis whitespace-nowrap"
                >
                  {{ product.company_name }}
                </span>
              </div>
            </div>
          </div>
          <!-- Product Info -->
          <div class="flex flex-col gap-y-4">
            <div class="flex items-center justify-between">
              <span class="max-w-[200px] font-medium">{{ product.name }} </span>

              <Icon
                @click.prevent="handleToggleWishList(product.id)"
                name="favorite"
                class="cursor-pointer text-primary transition-all duration-200"
                :type="product.is_in_wishlist ? 'filled' : 'outlined'"
              >
              </Icon>
            </div>

            <div class="flex items-center justify-start gap-x-2">
              <span>{{ product.points }} </span>
              <Icon name="jobful_points_variant"></Icon>
            </div>

            <div class="flex items-center justify-start gap-x-2">
              <template v-if="product.stock_status['in_stock']">
                <Icon
                  name="assignment_late"
                  type="filled"
                  class="text-[#10B981]"
                ></Icon>
                <span class="text-base font-medium">{{ __('In stock') }}</span>
              </template>

              <template v-if="product.stock_status['low_stock']">
                <Icon
                  name="assignment_late"
                  type="filled"
                  class="text-[#FFCC24]"
                ></Icon>
                <span class="text-base font-medium">{{ __('Low stock') }}</span>
              </template>

              <template v-if="product.stock_status['out_of_stock']">
                <Icon
                  name="assignment_late"
                  type="filled"
                  class="text-[#EF4444]"
                ></Icon>
                <span class="text-base font-medium">{{
                  __('Out of stock')
                }}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { defineProps } from 'vue';
  import { __ } from '@/helpers';

  import { useToast } from 'vue-toastification';
  import Icon from '@/components/global/Icon.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    }
  });

  const toast = useToast();
  const redirectToPage = (name, params) => {
    window.location.href = route(name, params);
  };

  const handleToggleWishList = async (productId) => {
    const response = await axios.post(
      route('redesign.candidate.shop.products.toggle_wishlist', productId)
    );

    if (response.data.message) {
      toast.success(response.data.message);
      props.data.product.recommended_products.data =
        props.data.product.recommended_products.data.map((product) => {
          if (product.id === productId) {
            return { ...product, is_in_wishlist: !product.is_in_wishlist };
          }
          return product;
        });
    } else {
      toast.error(response.data.message);
    }
  };
</script>
